module.exports = __webpack_public_path__ + "static/media/page-first.9ba3c058.svg";